export default __webpack_public_path__ + "static/media/Group8860.364ac7e0.svg";